import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'antd';

export default function CustomModal({
    children,
    title,
    isModalVisible,
    onCancelButtonClick,
    onAcceptButtonClick,
    cancelButtonText,
    acceptButtonText,
    subText,
    subTextAlign,
    width = 480,
    isAcceptButtonDisabled = false,
}) {
    return (
        <Modal
            title={title}
            open={isModalVisible}
            centered
            closable={false}
            width={width}
            footer={
                <div
                    className="modal__footer"
                    style={{
                        justifyContent: onAcceptButtonClick
                            ? 'space-between'
                            : 'center',
                    }}
                >
                    <button
                        className="modal__button modal__button-cancel"
                        onClick={onCancelButtonClick}
                    >
                        {cancelButtonText}
                    </button>
                    {onAcceptButtonClick && (
                        <button
                            className="modal__button modal__button-accept"
                            onClick={onAcceptButtonClick}
                            disabled={isAcceptButtonDisabled}
                            style={{
                                opacity: isAcceptButtonDisabled ? 0.5 : 1,
                                cursor: isAcceptButtonDisabled
                                    ? 'not-allowed'
                                    : 'pointer',
                            }}
                        >
                            {acceptButtonText}
                        </button>
                    )}
                </div>
            }
        >
            <p
                className="modal__sub-text"
                style={{
                    marginBottom: children && '16px',
                    textAlign: subTextAlign,
                }}
            >
                {subText}
            </p>
            {children}
        </Modal>
    );
}

CustomModal.propTypes = {
    /* Children elements */
    children: PropTypes.node,
    /* Modal title */
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    /* Is modal opened or not */
    isModalVisible: PropTypes.bool,
    /* Function to call on Cancel button click */
    onCancelButtonClick: PropTypes.func,
    /* Function to call on Accept button click */
    onAcceptButtonClick: PropTypes.func,
    /* Cancel button text */
    cancelButtonText: PropTypes.string,
    /* Accept button text */
    acceptButtonText: PropTypes.string,
    /* Text under main title */
    subText: PropTypes.string,
    /* Align text under main title*/
    subTextAlign: PropTypes.string,
    /* Disable accept button */
    isAcceptButtonDisabled: PropTypes.bool,
};
